<template>
  <div
    class="ct-radio-item"
    @click.prevent="clickItem">
    <ct-icon
      :name="iconName"
      :multi-color="isMoulti"></ct-icon>
    <input
      class="ct-radio-item-input"
      type="radio"
      :value="label">
   </div>
</template>

<script>
export default {
  name: 'Radio',
  props: {
    label: String,
    disabled: Boolean,
    value: {
      getters (value) {
        return value.toString()
      }
    }
  },
  data () {
    return {
      prefix: 'ct-radio',
      name: `radio`
    }
  },
  mounted () {
  },
  methods: {
    clickItem () {
      if (!this.disabled) this.$emit('input', this.label)
    }
  },
  computed: {
    iconName () {
      return this.label === this.value ? this.disabled ? 'dxselecteddisabled'
        : 'dxselected' : this.disabled ? 'dxunselecteddisabled' : 'icon_o'
    },
    isMoulti () {
      return this.iconName !== 'icon_o'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
  .ct-radio-item {
  display: inline-block;
  font-size: 0;
  line-height: 16px;
  height: 16px;
  color: $secondary;
  cursor: pointer;
  margin-right: 30px;
  vertical-align: middle;

  > i,
  > svg {
    font-size: 14px;
    margin-right: 6px;
    line-height: 16px;
  }

  &:hover {
    > i {
      color: $primary;
    }
  }

  .ct-radio-item-input {
    display: none;
  }
  .ct-radio-item-text {
    font-size: 14px;
    display: inline-block;
    line-height: 16px;
  }
  .slotBox {
    display: inline-block;
    font-size: 14px;
  }
}
</style>
